import React from 'react'
import { TABLA_DETALLE_DESCARGA_CON_MERMAS } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

function DetalleDescargaConMermasView () {
  return (
    <MuiTable id={TABLA_DETALLE_DESCARGA_CON_MERMAS} />
  )
}

export default DetalleDescargaConMermasView
